import { evidenceChain } from "@/mocks/home";

export default function EvidenceChain() {
  return (
    <section id="evidence" className="w-full mt-14 md:mt-20 bg-background-100/70 border-y border-background-200/80">
      <div className="w-full px-4 md:px-8 py-12 md:py-16 grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
        <div className="lg:col-span-4">
          <span className="font-label text-xs tracking-[0.3em] text-primary-600">线索台</span>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
            从一条线索到一条证据链
          </h2>
          <p className="mt-4 font-label text-sm leading-relaxed text-foreground-600">
            我们不会把未经核实的说法直接当成结论。每一条内容都会经过下面五个阶段，
            并明确标注它当前的确定性等级，让你清楚自己看到的是线索还是定论。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="px-3 py-1.5 rounded-md bg-secondary-100 text-secondary-900 font-label text-xs">
              已核实 · 双信源
            </span>
            <span className="px-3 py-1.5 rounded-md bg-accent-100 text-accent-900 font-label text-xs">
              待确认 · 单一信源
            </span>
            <span className="px-3 py-1.5 rounded-md bg-primary-100 text-primary-800 font-label text-xs">
              存在出入 · 持续跟进
            </span>
          </div>
          <a
            href="#board"
            className="mt-6 inline-flex items-center gap-2 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-label text-sm whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-send-plane-line"></i>
            提交一条线索
          </a>
        </div>

        <ol className="lg:col-span-8 relative">
          <span className="hidden md:block absolute left-[27px] top-3 bottom-3 w-px bg-background-300"></span>
          {evidenceChain.map((step, index) => (
            <li key={step.stage} className="relative flex gap-4 md:gap-6 pb-6 last:pb-0">
              <span
                className={`relative z-10 w-[54px] h-[54px] shrink-0 flex items-center justify-center rounded-full font-heading font-bold text-base ${
                  index === 4
                    ? "bg-accent-500 text-accent-950"
                    : "bg-background-50 border border-background-300 text-foreground-700"
                }`}
              >
                {step.stage}
              </span>
              <div className="flex-1 rounded-lg bg-background-50 border border-background-200/80 p-4 md:p-5">
                <div className="flex flex-wrap items-center gap-3">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">
                    {step.title}
                  </h3>
                  <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-900 font-label text-[11px]">
                    {step.label}
                  </span>
                </div>
                <p className="mt-2 font-label text-sm leading-relaxed text-foreground-600">
                  {step.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}